@use '@design/design-tokens/border-radius/border-radius' as *;
$shadow-color: #6592fd;

@keyframes gradientCycle {
  0% {
    background: conic-gradient(
      from 0deg,
      #9eb1ff,
      #3e63dd,
      #ff92ad,
      #e93d82,
      #29ffdc,
      #0eb39e,
      #9eb1ff
    );
  }

  12.5% {
    background: conic-gradient(
      from 45deg,
      #9eb1ff,
      #3e63dd,
      #ff92ad,
      #e93d82,
      #29ffdc,
      #0eb39e,
      #9eb1ff
    );
  }

  25% {
    background: conic-gradient(
      from 90deg,
      #ff92ad,
      #e93d82,
      #29ffdc,
      #0eb39e,
      #fbe577,
      #ffc53d,
      #ff92ad
    );
  }

  37.5% {
    background: conic-gradient(
      from 135deg,
      #ff92ad,
      #e93d82,
      #29ffdc,
      #0eb39e,
      #fbe577,
      #ffc53d,
      #ff92ad
    );
  }

  50% {
    background: conic-gradient(
      from 180deg,
      #29ffdc,
      #0eb39e,
      #fbe577,
      #ffc53d,
      #9eb1ff,
      #3e63dd,
      #29ffdc
    );
  }

  62.5% {
    background: conic-gradient(
      from 225deg,
      #29ffdc,
      #0eb39e,
      #fbe577,
      #ffc53d,
      #9eb1ff,
      #3e63dd,
      #29ffdc
    );
  }

  75% {
    background: conic-gradient(
      from 270deg,
      #fbe577,
      #ffc53d,
      #9eb1ff,
      #3e63dd,
      #ff92ad,
      #e93d82,
      #fbe577
    );
  }

  87.5% {
    background: conic-gradient(
      from 315deg,
      #fbe577,
      #ffc53d,
      #9eb1ff,
      #3e63dd,
      #ff92ad,
      #e93d82,
      #fbe577
    );
  }

  100% {
    background: conic-gradient(from 360deg, #9eb1ff, #3e63dd, #ff92ad);
  }
}

@keyframes loadingTransition {
  0% {
    --inset-size: -3px;
    --shadow-size: 5px;
    --scale: 1.01;
  }

  100% {
    --inset-size: -1px;
    --shadow-size: 2px;
    --scale: 1;
  }
}

.gradientWrapper {
  border-radius: 100px;

  &::before,
  &::after {
    content: '';
    position: absolute;
    border-radius: 100px;
    z-index: -1;
  }

  &.isDefault {
    &::before {
      inset: -1px;
      background: linear-gradient(
        120deg,
        #3e63dd,
        #9eb1ff,
        #ffc53d,
        #ff92ad,
        #e93d82
      );
    }

    &::after {
      inset: 0;
    }
  }

  &.isFinished {
    box-shadow: 0 0 5px 1px $shadow-color;

    &::before {
      inset: -1px;
      background: linear-gradient(
        120deg,
        #3e63dd,
        #9eb1ff,
        #ffc53d,
        #ff92ad,
        #e93d82
      );
    }

    &::after {
      inset: 0;
    }
  }

  &.isLoading {
    &::before {
      inset: -3px;
      animation: gradientCycle 1.5s linear infinite;
    }

    &::after {
      inset: 0;
    }

    animation: loadingTransition 1.5s ease-out forwards;

    &::before {
      inset: var(--inset-size, -3px);
    }

    box-shadow: 0 0 15px var(--shadow-size, 5px) $shadow-color;
    transform: scale(var(--scale, 1.01));
  }
}

.styledDropdown {
  width: 400px;
  min-width: 400px;
  max-width: 400px;
  margin-right: 0;
  padding: 0;
  @include border-radius-r2;

  [role='group'] {
    gap: 0;
    max-height: var(--dropdown-max-height);
    overflow-y: auto;

    > [data-dropdown-menu-item]:last-child > div {
      border-bottom: none;
    }
  }

  [data-dropdown-menu-item] > div {
    margin: 0;
    padding: 12px 8px;
    border-radius: 0;
    border-bottom: 1px solid var(--border-soft);
  }

  [role='group'] [data-highlighted]:first-child > div {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  [role='group'] [data-highlighted]:last-child > div {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }
}
